module.exports = __webpack_public_path__ + "media/nb_no_s3_Kaari.b3fd7754.mp3";